import React, { useCallback } from "react";

import { columns } from "../../constants";
import { FilterName, SelectedFilter } from "../../types";
import { TransitionProposalFlowStateData } from "@src/multiCustodian/components/TransitionProposals/types";
import Checkbox from "@src/sharedComponents/Checkbox/Checkbox";

import styles from "./HoldingFilterCheckbox.module.css";

interface HoldingFilterCheckboxProps {
  value: string;
  appliedFilter?: FilterName;
  checkedFilters: TransitionProposalFlowStateData["holdingsFilters"];
  onFilter: (filter: SelectedFilter) => void;
}

const HoldingFilterCheckbox: React.FC<HoldingFilterCheckboxProps> = ({
  value,
  appliedFilter,
  checkedFilters,
  onFilter,
}) => {
  const isChecked = appliedFilter
    ? checkedFilters[appliedFilter]?.includes(value)
    : false;

  const handleChange = useCallback(
    (checked: boolean) => {
      if (!appliedFilter) {
        return;
      }

      return onFilter({
        filterName: appliedFilter,
        value,
        checked,
      });
    },
    [appliedFilter, value, onFilter]
  );

  const getCheckBoxLabelAdornment = (label: string) => {
    const adornment = columns.find((c) => c.value === appliedFilter)?.adornment;

    if (adornment === undefined) {
      if (label.toLowerCase() === "n/a") {
        return "N/A";
      }
      return label
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }

    if (adornment === "%") {
      return `${label} ${adornment}`;
    }

    return `${adornment} ${label}!`;
  };

  return (
    <Checkbox
      checked={isChecked}
      onChange={handleChange}
      formControlClassName={styles.checkboxFormControl}
      label={getCheckBoxLabelAdornment(value)}
    />
  );
};

export default HoldingFilterCheckbox;
